import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import ComicSection from './components/ComicSection';
import { getHotComics, getLatestComics, getCompletedComics, getFeaturedComics } from '@/mocks/comics';

export default function Home() {
  useEffect(() => {
    document.title = '韩国漫画大全 - 免费在线韩漫阅读网 | 热门韩漫在线阅读';
  }, []);

  const hotComics = getHotComics(10);
  const latestComics = getLatestComics(10);
  const completedComics = getCompletedComics(8);
  const featuredComics = getFeaturedComics(5);

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画大全',
    url: typeof window !== 'undefined' ? window.location.origin : '',
    description: '韩国漫画大全网收录超万部韩漫作品，全部免费在线阅读，涵盖连载与完结经典之作，每日更新热门韩漫，适合韩漫爱好者收藏的一站式阅读平台。',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: typeof window !== 'undefined' ? `${window.location.origin}/search?q={search_term_string}` : '/search?q={search_term_string}'
      },
      'query-input': 'required name=search_term_string'
    }
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />

      <main>
        <HeroSection />

        <CategoryNav />

        <ComicSection
          title="热门推荐"
          subtitle="最受读者欢迎的韩漫作品"
          comics={hotComics}
          viewAllLink="/category/rexue"
          viewAllText="浏览全部"
        />

        <div className="bg-background-100">
          <ComicSection
            title="精选佳作"
            subtitle="评分最高的经典韩漫"
            comics={featuredComics}
          />
        </div>

        <ComicSection
          title="最新更新"
          subtitle="每日持续更新的连载韩漫"
          comics={latestComics}
          viewAllLink="/category/rexue"
          viewAllText="更多更新"
        />

        <div className="bg-background-100">
          <ComicSection
            title="完结经典"
            subtitle="一口气读到结局的经典作品"
            comics={completedComics}
            viewAllLink="/category/rexue"
            viewAllText="全部完结"
          />
        </div>

        <section className="py-10 md:py-14">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  为什么选择韩漫大全？
                </h2>
                <p className="text-sm text-foreground-500 mt-2">我们致力于为韩漫爱好者提供最优质的阅读体验</p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                {[
                  { icon: 'ri-book-read-line', title: '海量资源', desc: '收录超万部韩漫作品，涵盖八大分类，满足各类读者的阅读需求' },
                  { icon: 'ri-money-cny-circle-line', title: '完全免费', desc: '所有漫画全部免费在线阅读，无需付费订阅，无隐藏消费' },
                  { icon: 'ri-refresh-line', title: '每日更新', desc: '连载漫画每日稳定更新，完结经典随时畅读，精彩内容不间断' },
                  { icon: 'ri-device-line', title: '多端适配', desc: '支持电脑、平板、手机等多种设备阅读，随时随地享受韩漫' }
                ].map((feature) => (
                  <div key={feature.title} className="p-5 md:p-6 rounded-lg bg-background-100 text-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mx-auto mb-4">
                      <i className={`${feature.icon} text-xl`}></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-2">{feature.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                开始你的韩漫之旅
              </h2>
              <p className="text-sm text-foreground-500 mb-6 leading-relaxed">
                无论你是韩漫老粉还是刚刚入门的新读者，韩漫大全都为你准备了丰富的漫画资源。从热血战斗到浪漫恋爱，从悬疑惊悚到搞笑日常，总有一部作品能打动你的心。
              </p>
              <a
                href="/category/rexue"
                className="inline-block whitespace-nowrap px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer"
              >
                立即探索
              </a>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}